import { ACTIVE_CAMPAIGN_STATUSES, ICampaign } from "campaign/model"

export function getDeliveryIndex(campaign: ICampaign): undefined | number {
  if (!ACTIVE_CAMPAIGN_STATUSES.includes(campaign.status_id)) {
    return undefined
  }
  const timeCompletionRatio = getTimeCompletionRatio(campaign)
  if (timeCompletionRatio === undefined) {
    return undefined
  }
  const completionRatio = getCompletionRatio(campaign)
  if (completionRatio === undefined) {
    return undefined
  }
  const timePercent = timeCompletionRatio * 100
  const deliverablePercent = completionRatio * 100
  return deliverablePercent - timePercent
}

function getCompletionRatio({ budget, max_views, views, total_spend }: ICampaign) {
  let deliverableRatio = 0.0
  if (views !== null && max_views && max_views > 0) {
    deliverableRatio = (views as any) / max_views
  } else if (total_spend !== null && budget) {
    deliverableRatio = Math.max(deliverableRatio, total_spend / budget)
  }
  return deliverableRatio
}

function getTimeCompletionRatio({ start_date, end_date }: ICampaign): undefined | number {
  if (start_date === null || end_date === null || start_date === end_date) {
    return undefined
  }
  const start = new Date(start_date)
  const end = new Date(end_date)
  const now = new Date()
  const totalDuration = end.getTime() - start.getTime()
  const currentDuration = now.getTime() - start.getTime()
  let ratio = currentDuration / totalDuration
  ratio = Math.max(ratio, 0.0)
  return Math.min(ratio, 1.0)
}
